import { useSelector } from 'react-redux'
import { selectUser } from '../modules/user/selectors'
import {
  useAuthenticateConnectedUser,
  useDynamicContext,
  useIsLoggedIn as useDynamicIsLoggedIn,
} from '@dynamic-labs/sdk-react-core'
import { selectAccount } from '../modules/web3/selectors'

const useIsLoggedIn = () => {
  const { primaryWallet } = useDynamicContext()
  const { isAuthenticating } = useAuthenticateConnectedUser()
  const user = useSelector(selectUser)

  const { address } = primaryWallet ?? {}
  const isConnected = useDynamicIsLoggedIn()

  /**
   * WARN: We should no longer check for the user's wallet address. With dynamic, the user can have multiple wallets
   * The wallet check is made in the login request. So if the user is logged in, just carry on.
   */
  const isLoggedIn = !!isConnected && !!address && !!user

  return { isLoggedIn, user, address, isAuthenticating }
}

export function useIsLoggedInAndAuthenticated() {
  const account = useSelector(selectAccount)
  const user = useSelector(selectUser)

  const isLoggedInAndAuthenticated =
    !!account &&
    !!user?.walletAddress &&
    account.toLowerCase() === user?.walletAddress.toLowerCase()

  return isLoggedInAndAuthenticated
}

export default useIsLoggedIn
